import { AbstractControl, ValidatorFn } from '@angular/forms';
import { PhoneNumberUtil } from 'google-libphonenumber';

enum PhoneRegion {
  NL = 'NL',
}

export function phoneValidator(
  defaultRegion: PhoneRegion = PhoneRegion.NL,
): ValidatorFn {
  const phoneUtil = PhoneNumberUtil.getInstance();
  return (control: AbstractControl) => {
    const raw = (control.value || '').toString().trim();
    if (!raw) return null;
    try {
      const parsed = phoneUtil.parseAndKeepRawInput(raw, defaultRegion);
      if (!phoneUtil.isValidNumber(parsed)) {
        return { phoneInvalid: true };
      }
      return null;
    } catch {
      return { phoneInvalid: true };
    }
  };
}
